export const Permissions = {
  accounts: {
    get: 'accounts:Get',
    update: 'accounts:Update'
  },
  projects: {
    inviteTeamMember: 'projects:InviteTeamMember',
    updateTeamMember: 'projects:UpdateTeamMember',
    create: 'projects:Create',
    update: 'projects:Update',
    delete: 'projects:Delete'
  },
  groups: {
    create: 'groups:Create',
    update: 'groups:Update',
    delete: 'groups:Delete',
    moveUser: 'groups:MoveUser'
  },
  carriers: {
    create: 'carriers:Create',
    update: 'carriers:Update'
  },
  users: {
    get: 'users:Get',
    update: 'users:Update',
    create: 'users:Create',
    batchImport: 'users:BatchImport'
  },
  deliveries: {
    get: 'deliveries:Get',
    create: 'deliveries:Create',
    update: 'deliveries:Update',
    delete: 'deliveries:Delete',
    cancel: 'deliveries:Cancel',
    sendNotification: 'deliveries:SendNotification',
    forceUpdate: 'deliveries:ForceUpdate'
  },
  deliveryContainers: {
    open: 'deliverycontainers:Open',
    update: 'deliverycontainers:Update'
  },
  hubs: {
    list: 'hubs:List',
    create: 'hubs:Create',
    update: 'hubs:Update',
    delete: 'hubs:Delete',
    openAllDoors: 'hubs:OpenAllDoors'
  },
  notes: {
    create: 'notes:Create',
    createPrivate: 'notes:CreatePrivate'
  },
  settings: {
    updateBasic: 'settings:UpdateBasic',
    updateAdvanced: 'settings:UpdateAdvanced'
  }
};
